var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "lab-results-page"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Filtrování\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 text-center"
  }, [(_vm.doctors.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignedTo),
      expression: "assignedTo"
    }],
    staticClass: "mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "data-testid": "lab-results-doctor-filter"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assignedTo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("všichni doktoři")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.selectedStates.indexOf('accepted') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "accepted",
      "data-testid": "lab-results-filter-accepted"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('accepted')
      }
    }
  }, [_vm._v("nepřiřazené")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "accepted",
      "data-testid": "lab-results-filter-accepted"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('accepted'), 1)
      }
    }
  }, [_vm._v("nepřiřazené")]), _vm._v(" "), (_vm.selectedStates.indexOf('assigned') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "assigned",
      "data-testid": "lab-results-filter-assigned"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('assigned')
      }
    }
  }, [_vm._v("nevyhodnocené")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "assigned",
      "data-testid": "lab-results-filter-assigned"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('assigned'), 1)
      }
    }
  }, [_vm._v("nevyhodnocené")]), _vm._v(" "), (_vm.selectedStates.indexOf('wait_for_doctor') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "wait_for_doctor",
      "data-testid": "lab-results-filter-wait-for-doctor"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('wait_for_doctor')
      }
    }
  }, [_vm._v("předáno na doktora")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "wait_for_doctor",
      "data-testid": "lab-results-filter-wait-for-doctor"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('wait_for_doctor'), 1)
      }
    }
  }, [_vm._v("předáno na doktora")]), _vm._v(" "), (_vm.selectedStates.indexOf('completed') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "canceled",
      "data-testid": "lab-results-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('completed')
      }
    }
  }, [_vm._v("dokončeno")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "canceled",
      "data-testid": "lab-results-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('completed'), 1)
      }
    }
  }, [_vm._v("dokončeno")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "data-testid": "lab-results-refresh"
    },
    on: {
      "click": function($event) {
        _vm.getDoctorsDayTasks()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])]), _vm._v(" "), (_vm.listData.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.listData), function(task, index) {
    return [_c('tr', {
      staticClass: "row m-0",
      class: _vm.openedTaskId === task.id ? 'border border-primary border-bottom-0' : '',
      attrs: {
        "data-testid": 'lab-results-row-' + task.id
      }
    }, [_c('td', {
      staticClass: "align-middle col-sm-1"
    }, [(_vm.openedTaskId === task.id) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "data-testid": 'lab-results-toggle-' + task.id
      },
      on: {
        "click": function($event) {
          _vm.openTaskId(task.id, task)
        }
      }
    }, [_vm._v("-")]) : _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": 'lab-results-toggle-' + task.id
      },
      on: {
        "click": function($event) {
          _vm.openTaskId(task.id, task)
        }
      }
    }, [_vm._v("+")])]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-sm-2",
      attrs: {
        "data-testid": 'lab-results-state-' + task.id
      }
    }, [_vm._v("\n                        " + _vm._s(_vm._f("taskStateToCS")(task.state)) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3",
      attrs: {
        "data-testid": 'lab-results-client-' + task.id
      }
    }, [(task.client) ? [_c('router-link', {
      staticClass: "text-secondary",
      attrs: {
        "to": {
          name: 'ShowClient',
          params: {
            clientid: task.client.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-address-card-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v("\n                            " + _vm._s(task.client.full_name) + "\n                        ")] : [_vm._v("klient nepřiřazen")]], 2), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3",
      attrs: {
        "data-testid": 'lab-results-doctor-' + task.id
      }
    }, [_vm._v("\n                        " + _vm._s(task.assigned_to ? task.assigned_to.fullname : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3",
      attrs: {
        "data-testid": 'lab-results-received-' + task.id
      }
    }, [_vm._v("\n                        " + _vm._s(task.received_on) + "\n                    ")])]), _vm._v(" "), (_vm.openedTaskId === task.id) ? _c('tr', {
      staticClass: "row m-0 border border-primary border-top-0",
      attrs: {
        "data-testid": 'lab-results-detail-' + task.id
      }
    }, [_c('td', {
      staticClass: "col-md-6"
    }, [_c('b', [_vm._v("Laboratorní výsledek:")]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "p-4",
      staticStyle: {
        "white-space": "pre-wrap",
        "font-family": "monospace, monospace"
      },
      attrs: {
        "id": "result_text",
        "data-testid": 'lab-results-content-' + task.id
      },
      domProps: {
        "innerHTML": _vm._s(task.result)
      },
      on: {
        "click": _vm.copyResultText
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "col-md-6"
    }, [_c('div', [(task.client) ? [(task.state !== 'completed') ? [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      attrs: {
        "for": "exampleFormControlTextarea1"
      }
    }, [_vm._v("Zpráva klientovi:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Dobrý den,")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedTask.evaluation),
        expression: "updatedTask.evaluation"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "exampleFormControlTextarea1",
        "rows": "10",
        "data-testid": 'lab-results-evaluation-' + task.id
      },
      domProps: {
        "value": (_vm.updatedTask.evaluation)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.updatedTask.evaluation = $event.target.value
        }
      }
    }), _vm._v(" "), _vm._m(2, true)]), _vm._v(" "), _c('div', [_c('label', {
      attrs: {
        "for": "includeResultToMessage"
      }
    }, [_vm._v("Přidat laboratorní výsledek do zprávy")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedTask.include_result_to_email),
        expression: "updatedTask.include_result_to_email"
      }],
      attrs: {
        "type": "checkbox",
        "id": "includeResultToMessage",
        "data-testid": 'lab-results-include-result-' + task.id
      },
      domProps: {
        "checked": Array.isArray(_vm.updatedTask.include_result_to_email) ? _vm._i(_vm.updatedTask.include_result_to_email, null) > -1 : (_vm.updatedTask.include_result_to_email)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.updatedTask.include_result_to_email,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.updatedTask.include_result_to_email = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.updatedTask.include_result_to_email = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.updatedTask.include_result_to_email = $$c
          }
        }
      }
    })]), _vm._v(" "), (task.client.email_address.length < 1) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("Nelze odpovědět, klient nemá vyplněnou emailovou adresu.")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row justify-content-between m-0"
    }, [_c('div', [(task.client.email_address.length > 0) ? _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "data-testid": 'lab-results-complete-email-' + task.id
      },
      on: {
        "click": _vm.completeAndSubmit
      }
    }, [_vm._v("Odpovědět a odsplnit")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-outline-success",
      attrs: {
        "data-testid": 'lab-results-complete-' + task.id
      },
      on: {
        "click": _vm.setWithoutEmail
      }
    }, [_vm._v("Pouze odsplnit")])]), _vm._v(" "), (_vm.hasRole('doctor')) ? _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "data-testid": 'lab-results-prescription-' + task.id
      },
      on: {
        "click": _vm.showModalClientMedicament
      }
    }, [_vm._v("Vypsat recept")]) : _vm._e(), _vm._v(" "), (task.state === 'assigned') ? _c('button', {
      staticClass: "btn btn-warning",
      attrs: {
        "data-testid": 'lab-results-hand-off-' + task.id
      },
      on: {
        "click": _vm.handOverToDoctroAndSubmit
      }
    }, [_vm._v("Předat na doktora")]) : _vm._e(), _vm._v(" "), _c('client-medicament', {
      attrs: {
        "prop-client": task.client
      }
    })], 1)] : [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      attrs: {
        "for": "evaluationSent"
      }
    }, [_vm._v("Zpráva odeslaná klientovi:")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedTask.evaluation),
        expression: "updatedTask.evaluation"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "evaluationSent",
        "rows": "10",
        "disabled": "disabled"
      },
      domProps: {
        "value": (_vm.updatedTask.evaluation)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.updatedTask.evaluation = $event.target.value
        }
      }
    })])]] : [_c('multiselect', {
      attrs: {
        "reset-after": false,
        "id": "search",
        "label": "label",
        "track-by": "code",
        "placeholder": "vyhledat klienta",
        "open-direction": "bottom",
        "options": _vm.clients,
        "multiple": false,
        "searchable": true,
        "internal-search": false,
        "close-on-select": true,
        "options-limit": 300,
        "limit": 3,
        "max-height": 600,
        "show-no-results": false,
        "clear-on-select": true,
        "selectLabel": "",
        "data-testid": 'lab-results-client-search-' + task.id
      },
      on: {
        "search-change": _vm.getResult,
        "select": _vm.selectClient
      },
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    }), _vm._v(" "), (_vm.selected) ? _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "data-testid": 'lab-results-assign-' + task.id
      },
      on: {
        "click": _vm.assignAndSubmit
      }
    }, [_vm._v("Přiřadit klienta")]) : _c('button', {
      staticClass: "btn btn-success disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_vm._v("Přiřadit klienta")])]], 2), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', [_vm._l((_vm.tasks), function(task, index) {
      return [_c('tr', {
        staticClass: "row m-0",
        class: _vm.openedClientTaskId === index ? 'border border-primary border-bottom-0' : ''
      }, [_c('td', {
        staticClass: "align-middle col-sm-1"
      }, [(_vm.openedClientTaskId === index) ? _c('button', {
        staticClass: "btn btn-sm btn-primary",
        on: {
          "click": function($event) {
            _vm.openClientTaskId(index, task)
          }
        }
      }, [_vm._v("-")]) : _c('button', {
        staticClass: "btn btn-sm btn-secondary",
        on: {
          "click": function($event) {
            _vm.openClientTaskId(index, task)
          }
        }
      }, [_vm._v("+")])]), _vm._v(" "), _c('td', {
        staticClass: "col-sm-3"
      }, [_vm._v(_vm._s(task.date_cs))]), _vm._v(" "), _c('td', {
        staticClass: "col-sm-3"
      }, [(task.type === 'lab_result') ? _c('span', [_c('i', {
        staticClass: "fa fa-flask fa-lg",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Laboratorní výsledek")]) : _c('span', [_c('i', {
        staticClass: "fa fa-pencil-square-o",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Lékařská zpráva")])]), _c('td', {
        staticClass: "col-sm-5"
      })]), _vm._v(" "), (_vm.openedClientTaskId === index) ? _c('tr', {
        staticClass: "row m-0 border border-primary border-top-0"
      }, [(task.type === 'lab_result') ? _c('td', {
        staticClass: "col-md-12"
      }, [_c('b', [_vm._v("Laboratorní výsledek")]), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "p-4",
        staticStyle: {
          "white-space": "pre-wrap",
          "font-family": "monospace, monospace"
        },
        attrs: {
          "id": "result_text"
        },
        domProps: {
          "innerHTML": _vm._s(task.result)
        }
      }), _vm._v(" "), _c('b', [_vm._v("Hodnocení")]), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "p-4",
        staticStyle: {
          "white-space": "pre-wrap",
          "font-family": "monospace, monospace"
        },
        attrs: {
          "id": "result_text"
        },
        domProps: {
          "innerHTML": _vm._s(task.evaluation)
        }
      })]) : _c('td', {
        staticClass: "col-md-12"
      }, [_c('b', [_vm._v("Lékařská zpráva")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-sm btn-primary",
        on: {
          "click": function($event) {
            _vm.copyAndInsertReport(task.text)
          }
        }
      }, [_vm._v("Zkopírovat")]), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "p-4",
        staticStyle: {
          "white-space": "pre-wrap",
          "font-family": "monospace, monospace"
        },
        attrs: {
          "id": "result_text"
        },
        domProps: {
          "innerHTML": _vm._s(task.text)
        }
      }), _vm._v(" "), (task.visit) ? [_c('div', {}, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
        staticClass: "table"
      }, [_c('tbody', [_vm._l((task.visit.diagnosis), function(diagnose) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? [_vm._l((diagnose.actions), function(action) {
          return [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                              " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                            ")])]), _vm._v(" "), (action.zulp.length > 0) ? _vm._l((action.zulp), function(zulp) {
            return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                                   zulp: " + _vm._s(zulp.amount) + "x " + _vm._s(zulp.medicine.label) + "\n                                                              ")])])
          }) : _vm._e(), _vm._v(" "), (action.zum.length > 0) ? _vm._l((action.zum), function(zum) {
            return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                                   zum: " + _vm._s(zum.amount) + "x " + _vm._s(zum.material.label) + "\n                                                              ")])])
          }) : _vm._e()]
        })] : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(4, true)])]]
      })], 2)])])]), _vm._v(" "), _c('div', {}, [_c('h6', [_vm._v("Léčiva")]), _vm._v(" "), _c('div', [(task.visit.medicament.length > 0) ? [_c('table', {
        staticClass: "table"
      }, [_c('tbody', _vm._l((task.visit.medicament), function(m) {
        return _c('tr', [_c('td', [_vm._v(_vm._s(m.medicine ? m.medicine.label : '') + " " + _vm._s(m.individual_medicine ? m.individual_medicine.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.dosage))])])
      }))])] : [_c('i', [_vm._v("žádný lék nepředepsán")])]], 2)])] : _vm._e()], 2)]) : _vm._e()]
    })], 2)])])])]) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('pagination-component', {
    attrs: {
      "list-pagination": _vm.listPagination
    },
    on: {
      "set-page": _vm.setPage
    }
  })], 1) : (_vm.listPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(5)]) : _c('div', {
    staticClass: "card-body",
    attrs: {
      "data-testid": "lab-results-empty"
    }
  }, [_vm._m(6)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Laboratorní výsledky")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Stav")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Klient")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Doktor")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Datum přijetí")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_vm._v("S pozdravem"), _c('br'), _vm._v("\n                                                Urosanté")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-2"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("Datum odběru")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-5"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n                (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (nebyl nalezen žádný výsledek dle požadavků)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8ab72fc","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Result/components/Results.vue
// module id = 736
// module chunks = 0